import { fromJS } from 'immutable';
import actionTypes from 'constants/snapSellWizardConstants';

export const initialState = fromJS({
  currentStep: 1,
});

const snapSellWizardReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.SNAPSELL_GO_TO_NEXT_STEP:
      return state.set('currentStep', state.get('currentStep') + 1);
    case actionTypes.SNAPSELL_GO_TO_PREVIOUS_STEP:
      return state.set('currentStep', state.get('currentStep') - 1);
    case actionTypes.SNAPSELL_GO_TO_STEP:
      return state.set('currentStep', action.payload);
    default:
      return state;
  }
};

export default snapSellWizardReducer;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/snapSellWizardReducer.js